import { uniqBy } from "lodash-es";

import { AppPackageEditorFileTypes } from "../abstractions/EPackageEditor";
import { IAppPackageEditorFile } from "../abstractions/IPackageEditor";

export const extname = (filename: string) => filename.split('.').pop() || "";

export const getFilesForDirectory = (
  localFiles: IAppPackageEditorFile[],
  activeDirectory: string
) => {
  let strippedFiles = localFiles;
  strippedFiles = strippedFiles
    .filter((file) => file.name.includes(activeDirectory))
    .map((file) => {
      return {
        ...file,
        directoryName: file.name.replace(activeDirectory, ""),
      };
    })
    .map((file) => {
      if (file.directoryName.includes("/")) {
        return {
          ...file,
          directoryName: file.directoryName.split("/")[0],
          fileType: AppPackageEditorFileTypes.Folder
        }
      }
      return file;
    });
  const uniqueFiles = uniqBy(strippedFiles, 'directoryName');
  return uniqueFiles;
}

export const getFileAssets = (fileType: AppPackageEditorFileTypes) => {
  const asset = {
    extension: ["json"],
    src: getPackageEditorSrc(fileType)
  };
  switch (fileType) {
    case AppPackageEditorFileTypes.Icon:
    case AppPackageEditorFileTypes.Png:
      asset.extension = ["png"];
      break;
    case AppPackageEditorFileTypes.Yaml:
      asset.extension = ["yaml", "yml"];
      break;
    case AppPackageEditorFileTypes.OutLine:
      asset.extension = ["png"];
      break;
    case AppPackageEditorFileTypes.Folder:
      asset.extension = ["folder"];
      break;
  }
  return asset;
};

export const getPackageEditorSrc = (fileType: AppPackageEditorFileTypes) => {
  switch (fileType) {
    case AppPackageEditorFileTypes.Icon:
    case AppPackageEditorFileTypes.Png:
      return '/images/package-editor/pkgeditor-image.svg';
    case AppPackageEditorFileTypes.Yaml:
      return '/images/package-editor/pkgeditor-yaml.svg';
    case AppPackageEditorFileTypes.OutLine:
      return '/images/package-editor/pkgeditor-image.svg';
    case AppPackageEditorFileTypes.Folder:
      return '/images/package-editor/pkgeditor-folder.svg';
    default:
      return '/images/package-editor/pkgeditor-code.svg';
  }
}

export const base64ToUint8Array = (base64: string): Uint8Array => {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const packageEditorIconParse = (icon: string): Uint8Array => {
  // icons are parsed as [base64,`${base64Content}`]
  const base64 = icon.split(",");
  if (base64.length > 1) {
    return base64ToUint8Array(base64[1]);
  }
  return new Uint8Array();
};